export default "/images/ea5c6299609b21dd85bb05fa51270536.avif";